import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IcmsIcons } from '@icms/ui/icons/generated/icms-icons';
import { NCustomerGroups } from '../../customer/groups/customer-groups';

declare module '@icms/core/content/interfaces/icms-content-component.interfaces' {
    export namespace NICmsContentComponent {
        export interface IData {
            animation?: boolean;
            additional?: IComponentAdditional;
        }

        export interface IComponentAdditional {
            visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
        }
    }
}

export interface ICmsComponentCwvConfig {
    cwvPriority: boolean;
    // old data - do not use
    cwvWebp: boolean;
    cwvLoading: 'lazy' | 'eager';
    cwvFetchPriority: 'auto' | 'high' | 'low';
}

export const ICMS_GROUP_ADDITIONAL_ID = 'additional';

NICmsContentComponent.fieldGroupIcons[ICMS_GROUP_ADDITIONAL_ID] = IcmsIcons.MoreVert;

/**
 * Basic component fields
 */
export const BASIC_COMPONENT_FIELDS = [
    {
        type: NICmsContentField.EFieldType.label,
        key: 'section_animations',
        title: 'Animation'
    },
    {
        key: 'animation',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Initial animation',
        default: true
    }
];

export const CMS_COMPONENT_CWV_CONFIG = [
    <NICmsContentField.IField>{
        key: '_section-cwv',
        type: NICmsContentField.EFieldType.label,
        title: 'Core Web Vitals'
    },
    <NICmsContentField.IToggleField>{
        key: 'cwvPriority',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Image Priority',
        labels: {
            true: 'High',
            false: 'Normal'
        },
        default: false
    }
];
